import { useRouter } from 'next/router';
import { useStyles } from './styles';
import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';

export default function FlagsSelect() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const router = useRouter();
  const { locale } = router;
  const classes = useStyles();
  const languageMap = { en: '🇺🇸 English', es: '🇪🇸 Spanish' };

  function changeLanguage(e) {
    const locale = e.target.value;
    router.push(router.pathname, router.asPath, { locale });
  }

  return (
    <FormControl variant="filled" classes={{ root: classes.formControl }}>
      <InputLabel id="studyField-label" style={{ visibility: 'hidden' }}>
        Select Language
      </InputLabel>

      <Select
        variant="filled"
        labelId="studyField-label"
        name="idStudyField"
        id="studyField"
        value={locale}
        onChange={changeLanguage}
        classes={{ root: classes.selectRoot, select: classes.select }}
        disableUnderline={true}
        onOpen={() => setIsDropdownOpen(true)}
        onClose={() => setIsDropdownOpen(false)}
        inputProps={{
          'aria-controls': 'studyField-menu',
          'aria-expanded': isDropdownOpen,
        }}
        MenuProps={{
          id: 'studyField-menu',
        }}
        renderValue={(selected) => {
          return (
            <div role="textbox" aria-readonly="true" tabIndex={-1} aria-label="Selected language">
              {languageMap[selected] || 'Unknown'}
            </div>
          );
        }}
      >
        <MenuItem className={classes.menuItem} value="en" role="option">
          🇺🇸 English
        </MenuItem>
        <MenuItem className={classes.menuItem} value="es" role="option">
          🇪🇸 Spanish
        </MenuItem>
      </Select>
    </FormControl>
  );
}
